import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  countryLoad,
  countrySaveCurrency,
  countrySaveDeliveryDescription,
  countrySaveDeliveryTime,
  countrySaveDescription,
  countrySaveOriginCurrency,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(countryLoad.type, send, socket);
  yield takeEvery(countrySaveCurrency.type, send, socket);
  yield takeEvery(countrySaveDeliveryDescription.type, send, socket);
  yield takeEvery(countrySaveDeliveryTime.type, send, socket);
  yield takeEvery(countrySaveDescription.type, send, socket);
  yield takeEvery(countrySaveOriginCurrency.type, send, socket);
}
